module.exports = __webpack_public_path__ + "img/camoens_grotto_.4373f59e.jpg";